import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import ValidI18nMessage from 'marketplace-ui-common/i18n/components/ValidI18nMessage';
import { useCollections } from 'marketplace-ui-common/collections/hooks/useCollections';
import { isFulfilled } from 'marketplace-ui-common/requestStates/RequestStateUtils'; // @ts-expect-error untyped module

import { getIsUngatedForLinguine } from '../../selectors/auth';
import AssetStorefrontContainer from '../../storefront/containers/AssetStorefrontContainer';
import NotFoundError from '../../components/error/NotFoundError';
import { useFetchThemeCollectionOfferingIds } from '../hooks/useFetchThemeCollectionOfferingIds';
import { getIsInApp } from '../../selectors/app';
export default function ThemeCollectionContainer() {
  const {
    collection: slug
  } = useParams();
  const isLinguineUngated = useSelector(getIsUngatedForLinguine);
  const isInApp = useSelector(getIsInApp);
  const {
    getCollectionBySlug,
    requestState: collectionsRequestState
  } = useCollections({
    appContext: isInApp ? 'app' : 'public',
    offeringType: 'THEME'
  });
  const collection = getCollectionBySlug(slug);
  const {
    fetchThemeCollectionOfferingIds
  } = useFetchThemeCollectionOfferingIds({
    collectionId: collection ? collection.id : undefined
  });
  const handleFetchCollectionOfferingIds = useCallback(() => fetchThemeCollectionOfferingIds(), [fetchThemeCollectionOfferingIds]);

  if (!isFulfilled(collectionsRequestState)) {
    return null;
  }

  if (!(collection && collection.publishedListing)) {
    return /*#__PURE__*/_jsx(NotFoundError, {});
  }

  return /*#__PURE__*/_jsx(AssetStorefrontContainer, {
    collectionId: collection.id,
    title: isLinguineUngated ? collection.publishedListing.title : /*#__PURE__*/_jsx(ValidI18nMessage, {
      defaultValue: collection.publishedListing.title,
      message: `marketplace-assets-ui.collections.collection_${collection.id}.title`
    }),
    description: isLinguineUngated ? /*#__PURE__*/_jsx(SanitizedText, {
      body: collection.publishedListing.description,
      WrapperComponent: "span"
    }) : /*#__PURE__*/_jsx(ValidI18nMessage, {
      defaultValue: collection.publishedListing.description,
      message: `marketplace-assets-ui.collections.collection_${collection.id}.description`,
      messageComponent: FormattedHTMLMessage
    }),
    onFetchCollectionOfferingIds: handleFetchCollectionOfferingIds
  });
}